import { createUseStyles } from "react-jss";
import {breakpoints} from "../../../../constants/breakpoints";
import {colors} from "../../../../constants/colors";

const styles = createUseStyles(theme => ({
  teamsGrid: {
    margin: "32px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableCell": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px",
      color: colors.mediumGrey,
       [`@media (max-width: ${breakpoints.xs}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "16px",
      minWidth: "initial",
      [`@media (max-width: ${breakpoints.xs}px)`]: {
        maxWidth: "fit-content",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCol": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px",
      whiteSpace: "nowrap"
    },
    "& .rdt_TableCol:last-child": {
      minWidth: "initial"
    },
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.lightBlack,
    textOverflow: "ellipsis",
    overflow: "hidden"
  },

  invBtn: {
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "10px 10px",
    },
    height: "40px"
  },

  invBtnLoading: {
    backgroundColor: `${colors.white} !important`,
    border: theme.buttons.default.border,
    "& span": {
      borderColor: `${colors.grey} ${colors.grey} transparent !important`
    }
  },

  tooltipWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    gap: "9px"
  },
  cardContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    color: colors.mediumGrey,
    fontWeight: 400
  },
  numberOfUsers: {
    color: colors.mediumGrey,
  },
  noPolicy: {
    fontStyle: "italic",
    color: `${colors.darkGrey} !important`,
    cursor: "not-allowed",
    paddingRight: "5px"
  },
  assignedName: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    lineHeight: "20px",
    "& span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: colors.mediumGrey,
    },
  },
  extraCards: {
    display: "flex",
    padding: "2px 8px 2px 6px",
    backgroundColor: colors.veryLightGrey,
    borderRadius: "16px",
    gap: "4px",
    alignItems: "center",
    "& path": {
      stroke: colors.inactiveGrey
    },
    "& p": {
      margin: 0,
      fontSize: "12px",
      fontWeight: "500",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: colors.grey,
      lineHeight: "18px"
    },
  },
}));

export default styles;
